import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";

type AccessoryRow = {
  id: string;
  parameterKey: string;
  weight: string;
  price: string;
  unitKey: string;
  quantity: string;
  totalWeight: string;
  totalPrice: string;
  totalPriceNis: string;
};

const accessoryRows: AccessoryRow[] = [
  {
    id: "1",
    parameterKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.ROWS.FRONT_PROTECTOR",
    weight: "0",
    price: "₪ 0",
    unitKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.UNIT.UNIT",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "₪ 0",
    totalPriceNis: "0",
  },
  {
    id: "2",
    parameterKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.ROWS.REAR_PROTECTOR",
    weight: "70",
    price: "₪ 426,4",
    unitKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.UNIT.UNIT",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "₪ 0",
    totalPriceNis: "0",
  },
  {
    id: "3",
    parameterKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.ROWS.SLIDING_LADDER_NO_REINFORCEMENT",
    weight: "50",
    price: "₪ 1140",
    unitKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.UNIT.UNIT",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "₪ 0",
    totalPriceNis: "0",
  },
  {
    id: "4",
    parameterKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.ROWS.SLIDING_LADDER_REINFORCED",
    weight: "50",
    price: "₪ 290",
    unitKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.UNIT.UNIT",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "₪ 0",
    totalPriceNis: "0",
  },
  {
    id: "5",
    parameterKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.ROWS.BRAKE_INSTALLATION",
    weight: "9",
    price: "₪ 27,3",
    unitKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.UNIT.UNIT",
    quantity: "1",
    totalWeight: "9",
    totalPrice: "₪ 27,3",
    totalPriceNis: "27,3",
  },
  {
    id: "6",
    parameterKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.ROWS.GREASE",
    weight: "1",
    price: "₪ 45",
    unitKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.UNIT.UNIT",
    quantity: "1",
    totalWeight: "1",
    totalPrice: "₪ 45",
    totalPriceNis: "45",
  },
  {
    id: "7",
    parameterKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.ROWS.TOOLBOX_ONE",
    weight: "70,6",
    price: "₪ 500,82",
    unitKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.UNIT.UNIT",
    quantity: "1",
    totalWeight: "70,6",
    totalPrice: "₪ 500,82",
    totalPriceNis: "500,82",
  },
  {
    id: "8",
    parameterKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.ROWS.TOOLBOX_TWO",
    weight: "58,8",
    price: "₪ 411,38",
    unitKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.UNIT.UNIT",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "₪ 0",
    totalPriceNis: "0",
  },
  {
    id: "9",
    parameterKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.ROWS.OPEN_PLATFORM",
    weight: "59,5",
    price: "₪ 414,7",
    unitKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.UNIT.UNIT",
    quantity: "1",
    totalWeight: "59,5",
    totalPrice: "₪ 414,7",
    totalPriceNis: "414,7",
  },
  {
    id: "10",
    parameterKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.ROWS.WORKERS_LADDER",
    weight: "20",
    price: "$7,6",
    unitKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.UNIT.UNIT",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "$0",
    totalPriceNis: "0",
  },
  {
    id: "11",
    parameterKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.ROWS.REAR_LIGHTS",
    weight: "19,2",
    price: "₪ 87,78",
    unitKey: "QUOTES.DETAILS.SILAGI_ACCESSORIES.UNIT.UNIT",
    quantity: "0",
    totalWeight: "0",
    totalPrice: "₪ 0",
    totalPriceNis: "0",
  },
];

const QuotesAccessories = () => {
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={styles.root}>
      <Typography className={styles.title}>
        {t("QUOTES.DETAILS.SILAGI_ACCESSORIES.TITLE")}
      </Typography>

      <Box className={styles.list}>
        {accessoryRows.map((row) => (
          <Box className={styles.rowCard} key={row.id}>
            <Box className={styles.parameterCell}>
              <Typography className={styles.fieldLabel}>
                {t("QUOTES.DETAILS.SILAGI_ACCESSORIES.PARAMETER")}
              </Typography>

              <Typography className={styles.parameterValue}>
                {t(row.parameterKey)}
              </Typography>
            </Box>

            <Box className={styles.valuesGrid}>
              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.SILAGI_ACCESSORIES.WEIGHT")}
                </Typography>
                <Typography className={styles.fieldValue}>{row.weight}</Typography>
              </Box>

              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.SILAGI_ACCESSORIES.PRICE")}
                </Typography>
                <Typography className={styles.fieldValue}>{row.price}</Typography>
              </Box>

              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.SILAGI_ACCESSORIES.UNIT_LABEL")}
                </Typography>
                <Typography className={styles.fieldValue}>
                  {t(row.unitKey)}
                </Typography>
              </Box>

              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.SILAGI_ACCESSORIES.QUANTITY")}
                </Typography>
                <Typography className={styles.fieldValue}>{row.quantity}</Typography>
              </Box>

              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.SILAGI_ACCESSORIES.TOTAL_WEIGHT")}
                </Typography>
                <Typography className={styles.greenValue}>
                  {row.totalWeight}
                </Typography>
              </Box>

              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.SILAGI_ACCESSORIES.TOTAL_PRICE")}
                </Typography>
                <Typography className={styles.greenValue}>
                  {row.totalPrice}
                </Typography>
              </Box>

              <Box className={styles.valueCell}>
                <Typography className={styles.fieldLabel}>
                  {t("QUOTES.DETAILS.SILAGI_ACCESSORIES.TOTAL_PRICE_NIS")}
                </Typography>
                <Typography className={styles.greenValue}>
                  {row.totalPriceNis}
                </Typography>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default QuotesAccessories;